module.exports = __webpack_public_path__ + "static/img/mopaasbanner.39f2ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mopaasbanner.jpg
// module id = kcTf
// module chunks = 0